import axios from 'axios';
import { BABYFACE_URL } from '../routes/Routes';
import { ERROR_RETRY } from '../Error';
import queryString from 'query-string';

export const getBankAccount = ({ bankCode, bankAccount }) => {
  try {
    return axios.get(
      BABYFACE_URL.concat(
        `/order/payment/account-holder?${queryString.stringify({
          bankCode,
          accountNumber: bankAccount,
        })}`,
      ),
    );
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
